const formDataSchema ={
    feilds: [{
        id: 9,
        name: 'role_name',
        text: 'Dr. Priyatosh Tiwari',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Role Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
            id: 10,
            name: 'priyatosh_tiwari',
            text: 'Dr. Priyatosh Tiwari',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check (ER) Admission'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 11,
            name: 'sanjeet_minj',
            text: 'Dr. Sanjeet Minj',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check (ER) Financial Counselling'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3 pr-0'
        },{
            id: 12,
            name: 'brij_bhushan',
            text: 'Brij Bhushan',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check (ER) Billing Queries'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 12,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Financial Counselling'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 13,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Re-Counselling'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 13,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Discharge & Checkout'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 14,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Billing Queries'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 15,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Admission'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 16,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Payment'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 17,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Reimbursement'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 18,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Bill Tracking'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 19,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Manager Dashboard'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 20,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check Add New User'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 21,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Check Privilege Creation'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 22,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         //return (value !== null && value.length > 0);
                //         return true;
                //     },
                //     message: 'Please Check FC - Previlage Mapping'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        },{
            id: 23,
            name: 'Dr. Lorem Ipsum',
            text: 'Dr. Lorem Ipsum',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'checkbox',
            placeholder: 'Enter',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Check TAT Reports'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pt-3'
        }
    ]
}

export {formDataSchema};